__webpack_require__.p = "https://js-static.iimjobs.com/production/5.1.0/_next/";